import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { insAnketaChangeByKey } from 'store/insuranceAnketa';
import { FIELDS } from 'store/insuranceAnketa/constants';
import { selectField } from 'store/insuranceAnketa/selectors';

import { useDisabledFields } from '../../hooks/useDisabledFields';

export const useFormPresenter = ({ isOwnerForm }) => {
  const isDriverField = isOwnerForm ? FIELDS.OWNER_IS_DRIVER : FIELDS.KASKO_INSURER_IS_DRIVER;

  const dispatch = useDispatch();

  const isDriver = useSelector(selectField(isDriverField));

  const { disabled: pageRestrict } = useDisabledFields();

  const onChangeIsDriver = useCallback(
    (value) => {
      dispatch(insAnketaChangeByKey({ key: isDriverField, value }));
    },
    [isDriverField]
  );

  return { disabled: pageRestrict, isDriver, onChangeIsDriver };
};
